import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "12",
  fill: "currentColor"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#1ADF69",
  d: "M3.51 6.514C3.563 7.903 2.07 9.6.786 10.577l.926 1.389c.668-.36 5.091-3.189 5.091-8.126C6.802 2.246 5.414.857 3.82.857A2.985 2.985 0 0 0 .837 3.84c0 1.44 1.285 2.726 2.674 2.674m5.504 4.063.925 1.389c.669-.36 5.092-3.189 5.092-8.126 0-1.594-1.389-2.983-2.983-2.983A2.985 2.985 0 0 0 9.065 3.84c0 1.44 1.286 2.726 2.674 2.674.052 1.389-1.44 3.086-2.725 4.063"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }